module.exports = __webpack_public_path__ + "static/media/ro.f8cf5bc3.png";